export default {
  data() {
    return {};
  },
  computed: {
    // 是否为标准协议
    isStandardProtocol() {
      return `${this.info.protocolType}` === '1';
    },
    // 是否为衍生协议
    isDeriveProtocol() {
      return `${this.info.protocolType}` === '2';
    },
    // 是否为定制协议
    isCustomizedProtocol() {
      return `${this.info.protocolType}` === '3';
    }
  },
  methods: {
    // 格式化存储单位显示
    getStockUnit(row, defaultVal = '-') {
      if (this.dicMap && this.dicMap.iot_tsl_data_unit && row.dbUnit) {
        // const map = this.dicMap.iot_tsl_data_unit;
        return [row.dbRatio, row.dbUnit].join('');
      }
      return defaultVal;
    },
    // 格式化协议单位显示
    getProtocolUnit(row, defaultVal = '-') {
      if (this.dicMap && this.dicMap.iot_tsl_data_unit && row.tcpDataUnit) {
        // const map = this.dicMap.iot_tsl_data_unit;
        return [row.tcpDataRatio, row.tcpDataUnit].join('');
      }
      return defaultVal;
    },
    // 格式化协议单位显示
    getShowUnit(row, defaultVal = '-') {
      if (this.dicMap && this.dicMap.iot_tsl_data_unit && row.showUnit) {
        // const map = this.dicMap.iot_tsl_data_unit;
        return [row.showRatio, row.showUnit].join('');
      }
      return defaultVal;
    },
    getNeedTestTypes(types) {
      if (this.dicMap.iot_need_test_types && types) {
        const arr = types.split(',');
        const ret = arr.map((key) => {
          const strKey = `${key}`;
          return this.dicMap.iot_need_test_types[strKey];
        });
        return ret.join(',');
      }
      return '';
    }
  },
  mounted() {
    this.getDicMap('iot_tsl_data_unit');
    this.getDicMap('iot_need_test_types', () => {}, { propKey: 'value', propVal: 'name' });
  }
};
